import { useNavigate, useSearch } from '@tanstack/react-router';
import * as React from 'react';

import { SupplierHistoryScreen } from '@/routes/supplier/history/history-screen';

// =============================================================================
// history-route.tsx — Adaptateur routeur de l'HISTORIQUE FOURNISSEUR (DBU §3.9, Lot A).
// =============================================================================
// La SÉLECTION d'une participation (vue détail) est portée en ÉTAT D'URL (`?campaign=<id>`) via TanStack
// Router : partageable, compatible bouton retour, aucun état métier en localStorage (RULE_REF_006). Le
// composant de présentation reste testable hors routeur (props selectedCampaignId / onSelectCampaign).

/** Forme validée du search de la route historique (état d'URL de la vue détail). */
export interface HistorySearch {
  readonly campaign?: string;
}

export function SupplierHistoryRoute(): React.JSX.Element {
  const navigate = useNavigate();
  const search = useSearch({ strict: false }) as HistorySearch;
  const selectedCampaignId = search.campaign ?? null;

  const onSelectCampaign = React.useCallback(
    (campaignId: string | null): void => {
      void navigate({
        to: '/history',
        search: campaignId === null ? {} : { campaign: campaignId },
      });
    },
    [navigate],
  );

  return (
    <SupplierHistoryScreen
      selectedCampaignId={selectedCampaignId}
      onSelectCampaign={onSelectCampaign}
    />
  );
}
